export default "__VITE_ASSET__Dh1D2b8s__"